<template>
  <el-container class="background-white">
    <el-header>
      <h1>Order Change History</h1>
    </el-header>
    <el-main>
      <el-switch
        v-model="filterD365Missing"
        active-text="Filter Missing D365"
        inactive-text=""
        :disabled="loading"
        v-on:change="fetch">>
      </el-switch>
      <hr>
      <el-table v-loading="loading" :data="data.data"
                :row-class-name="tableRowHighlight">
        <el-table-column type="expand">
          <template slot-scope="props">
            <p v-if="props.row.d365_payload">
              <strong>D365 Status:</strong> {{props.row.d365_payload.state}}
            </p>
            <p><strong>Note:</strong> {{props.row.order_payload.note}}</p>
            <div v-if="props.row.refund_requested !== null">
              <div
                v-for="transaction in props.row.refund_requested.transactions">
                <hr>
                <p><strong>Kind:</strong> {{transaction.kind}}</p>
                <p><strong>Currency:</strong> {{transaction.currency}}</p>
                <p><strong>Amount:</strong> {{transaction.amount | currency}}
                </p>
                <p><strong>Maximum Refundable:</strong>
                  {{transaction.maximum_refundable | currency}}</p>
                <p><strong>Gateway:</strong> {{transaction.gateway}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="region"
                         label="Region"
                         width="100"/>
        <el-table-column label="Shopify Order ID">
          <template slot-scope="{row: {shopify_order_id, region}}">
            <router-link
              :to="{name: 'order-change-update', params: {
                region: region,
                id: shopify_order_id
              }}"
              target="_blank">{{shopify_order_id}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="Received by D365">
          <template slot-scope="props">
            {{props.row.processed_at | utcToLocal}}
          </template>
        </el-table-column>
        <el-table-column label="Refund Amount" align="center">
          <template slot-scope="{row: {refund_requested}}">
            <template v-if="refund_requested">
              {{sumRefundAvailable(refund_requested['transactions']) |
              currency}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="refunded_at" label="Refund Processed"/>
        <el-table-column prop="user.name" label="User"/>
        <el-table-column fixed="right" label="Actions" width="120">
          <template slot-scope="{row}">
            <el-button v-if="isRemovable(row)"
                       @click.prevent="deleteHandler(row)"
                       type="danger"
                       size="small">Remove
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        background
        layout="prev, pager, next, ->, total"
        :page-size="data.per_page"
        :total="data.total"
        :page-count="data.last_page"
        :current-page="data.current_page"
        @current-change="currentChangeHandler"
        @size-change="sizeChangeHandler">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import {currency} from '../../../filters';
  import {RepositoryFactory} from '../../../repositories/RepositoryFactory';
  import moment from 'moment';

  const OCAEditHistoryRepository = RepositoryFactory.get(
    'acadia/oca/edit-history');

  export default {
    name: 'OrderUpdateHistoryPage',
    created() {
      this.fetch();
    },
    data() {
      return {
        loading: true,
        headers: {},
        data: {},
        url: '/api/order-change-app/edit-history',
        sizes: [10, 20, 30, 40, 50],
        limit: 5,
        page: 1,
        filterRefundMissing: false,
        filterD365Missing: false,
      };
    },
    methods: {
      fetch() {
        this.loading = true;

        OCAEditHistoryRepository.index({
          params: {
            page: this.page,
            limit: this.limit,
            filter_refund_missing: this.filterRefundMissing
              ? 'active'
              : 'inactive',
            filter_d365_missing: this.filterD365Missing
              ? 'active'
              : 'inactive',
          },
        }).then(response => {
          this.data = response.data;
        }).finally(() => {
          this.loading = false;
        });
      },
      currentChangeHandler(page) {
        this.page = page;
        this.fetch();
      },
      sizeChangeHandler(limit) {
        this.limit = limit;
        this.fetch();
      },
      deleteHandler({id}) {
        this.loading = true;

        OCAEditHistoryRepository.destroy(id).then(() => {
          this.fetch();
        }).catch(error => {
          throw error;
        }).finally(() => {
          this.loading = false;
        });
      },
      refundHandler({id}) {
        this.loading = true;

        OCAEditHistoryRepository.update(id, {refunded_at: moment().format()}).
          then(() => {
            this.fetch();
          }).
          catch(error => {
            throw error;
          }).finally(() => {
          this.loading = false;
        });
      },
      sumRefundAvailable(transactions) {
        const reducer = (amount, transaction) => (amount +
          Number(transaction.amount));
        return transactions.reduce(reducer, 0);
      },
      isRemovable(row) {
        if(row.refund_requested) {
          const {refund_requested: {transactions}} = row;
          return !this.refundAvailable(transactions) && !row.processed_at;
        } else {
          return !row.processed_at
        }
      },
      refundAvailable(transactions) {
        return Number(transactions.reduce((amount, transaction) => {
          return amount + transaction['amount'];
        }, 0)) > 0;
      },
      tableRowHighlight({row, rowIndex}) {
        if(row.refund_requested) {
          const {refund_requested: {transactions}} = row;
          if (this.refundAvailable(transactions) && !row.refunded_at) {
            return 'warning-row';
          }
        }
        return '';
      },
    },
    filters: {
      currency,
      utcToLocal: function(value) {
        if (value) {
          return moment.utc(value).local().format('YYYY-MM-DD hh:mm:ss');
        }
        return '';
      },
    },
  };
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }
</style>
